<template>
    <img src="/img/uploadImage.svg" alt="">
</template>

<script>
export default {

}
</script>